// src/helpers/register/reducerHelpers/printingErrors.ts
var updateOrderWithPrintingErrors = (order, printingErrors) => {
  Object.values(printingErrors.ticketElementIdsWithErrors).forEach(
    (ticketElementWithError) => {
      order.printerError = true;
      let accessId;
      if (order.ticketElements[ticketElementWithError.ticketElementId])
        accessId = ticketElementWithError.ticketElementId;
      else
        accessId = ticketElementWithError.tabletGeneratedId;
      if (accessId) {
        order.ticketElements[accessId].printErrorMessage[ticketElementWithError.printJobId] = {
          sentTime: printingErrors.sentToKitchenTime,
          prepStationId: ticketElementWithError.prepStationId,
          printJobId: ticketElementWithError.printJobId,
          isErrored: true,
          errorCode: ticketElementWithError.errorCode,
          isCleared: false
        };
        if (ticketElementWithError.prepStationId === null) {
          const prepStationHistory = order.ticketElements[accessId].sentToPrepStationHistory.filter(
            (sentToPrepStation) => sentToPrepStation.printerId && sentToPrepStation.printerId === ticketElementWithError.printerId
          ).reverse();
          const prepStationHistoryRecord = prepStationHistory.find(
            (record) => record.printJobErrorId === null
          );
          if (prepStationHistoryRecord) {
            prepStationHistoryRecord.printJobErrorId = ticketElementWithError.printJobId;
          }
        } else {
          const prepStationHistory = order.ticketElements[accessId].sentToPrepStationHistory.filter(
            (sentToPrepStation) => sentToPrepStation.prepStationId === ticketElementWithError.prepStationId
          ).reverse();
          const prepStationHistoryRecord = prepStationHistory.find(
            (record) => record.printJobErrorId === null
          );
          if (prepStationHistoryRecord) {
            prepStationHistoryRecord.printJobErrorId = ticketElementWithError.printJobId;
          }
        }
      }
    }
  );
};
var clearOrderItemPrintingError = (order, ticketElementId) => {
  if (order.ticketElements[ticketElementId].printErrorMessage) {
    Object.values(
      order.ticketElements[ticketElementId].printErrorMessage
    ).forEach((printError) => {
      printError.isCleared = true;
    });
  }
  const orderHasPrintingError = Object.values(order.ticketElements).some(
    (ticketElement) => Object.values(ticketElement.printErrorMessage).some(
      (printError) => printError.isErrored && !printError.isCleared
    )
  );
  if (!orderHasPrintingError) {
    order.printerError = false;
  }
};

export { clearOrderItemPrintingError, updateOrderWithPrintingErrors };
